import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';

type RaceBonusClaim = {
  id: string;
  bonus_slug: string;
  amount_eur: number;
  threshold: number;
  claimed_at: string;
  winner_acknowledged_at: string | null;
};

export function usePendingRaceClaim(userId: string | undefined) {
  return useQuery({
    queryKey: ['race-bonus', 'pending', userId],
    queryFn: async (): Promise<RaceBonusClaim | null> => {
      const items = await pb.collection('bonus_claims').getList(1, 1, {
        filter: `winner = "${userId}" && winner_acknowledged_at = ""`,
        sort: '-claimed_at',
      });
      return items.items.length > 0
        ? (items.items[0] as unknown as RaceBonusClaim)
        : null;
    },
    enabled: !!userId,
    staleTime: 60_000,
  });
}

export function useAcknowledgeClaim() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (claimId: string): Promise<unknown> =>
      pb.send(`/api/race-bonus/acknowledge/${claimId}`, { method: 'POST' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['race-bonus'] });
    },
  });
}
